import React from 'react';
import { motion } from 'framer-motion';
import { CalendarIcon, MailIcon, MapPinIcon, PhoneIcon, ArrowRightIcon } from 'lucide-react';
const CITY_IMAGE = 'https://cdn.magicpatterns.com/uploads/bFwPotEiUH11PrZDHLUZww/LasVegasMarketingCompany.jpg';
const contactMethods = [{
  label: 'Local Phone',
  value: '(702) 213-4801',
  href: 'tel:17022134801',
  helper: "Text 'START' to opt in to our text message list",
  icon: PhoneIcon
}, {
  label: 'Email',
  value: 'Results@GetAdROI.com',
  href: 'mailto:Results@GetAdROI.com',
  icon: MailIcon
}, {
  label: 'Schedule a Meeting',
  value: 'Click here to book a meeting',
  href: 'mailto:Results@GetAdROI.com?subject=Book%20a%20Meeting',
  icon: CalendarIcon
}, {
  label: 'Address',
  value: '4730 S. Fort Apache Rd., Suite 300, Las Vegas, NV 89147',
  href: 'https://maps.google.com/?q=4730+S+Fort+Apache+Rd+Suite+300+Las+Vegas+NV+89147',
  icon: MapPinIcon
}];
export function Contact() {
  return <>
      <section className="bg-brand-red px-4 py-20 text-center sm:px-6 lg:px-8 lg:py-28" data-id="element-694" data-mp="15edtbt9fzopg">
        <motion.h1 initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="text-5xl font-extrabold tracking-tight text-white sm:text-6xl" data-id="element-695" data-mp="19g8qclkcbfxf">
          Contact Us
        </motion.h1>
        <p className="mx-auto mt-4 max-w-xl text-lg text-white/85" data-id="element-696" data-mp="mhmcdqhdhlok">
          Your Las Vegas marketing department — one call, text, or email away.
        </p>
      </section>

      <section className="bg-white px-4 py-20 sm:px-6 lg:px-8 lg:py-24" data-id="element-697" data-mp="vhitn71fni9l">
        <div className="mx-auto grid max-w-7xl items-center gap-12 lg:grid-cols-2 lg:gap-16" data-id="element-698" data-mp="vjlu6l07otsk">
          <div className="overflow-hidden rounded-2xl shadow-xl" data-id="element-699" data-mp="10e99pud8mdv0">
            <img src={CITY_IMAGE} alt="The Las Vegas Strip at night, home of AdROI Marketing" className="aspect-[3/2] h-full w-full object-cover" data-id="element-700" data-mp="26vmo0ebxn8f6" />
          </div>

          <div data-id="element-701" data-mp="1m5ir60nb5pcc">
            <h2 className="text-3xl font-extrabold tracking-tight text-brand-black sm:text-4xl" data-id="element-702" data-mp="1m96jwxkxi7q0">Let's talk results.</h2>
            <p className="mt-4 text-lg leading-relaxed text-brand-gray" data-id="element-703" data-mp="1w59mg4jp08dh">
              Call, text, email, or book a meeting — however works best for you. We respond fast.
            </p>

            <ul className="mt-10 divide-y divide-gray-200 border-y border-gray-200" data-id="element-704" data-mp="13gvmvkcyh3zt">
              {contactMethods.map(method => <li key={method.label} className="flex items-start gap-4 py-5" data-id="element-705" data-mp="yikezf6813k8">
                  <span className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-md bg-brand-tint text-brand-red" data-id="element-706" data-mp="1d7724323azm0">
                    <method.icon className="h-5 w-5" aria-hidden="true" data-id="element-707" data-mp="18f6xvyezlkjm" />
                  </span>
                  <div data-id="element-708" data-mp="kp32uffv6t48">
                    <p className="text-xs font-bold uppercase tracking-[0.14em] text-brand-gray" data-id="element-709" data-mp="ko9vbc92zzl1">{method.label}</p>
                    <a href={method.href} target={method.href.startsWith('http') ? '_blank' : undefined} rel={method.href.startsWith('http') ? 'noreferrer' : undefined} className="mt-1 inline-block text-base font-semibold text-brand-black transition-colors duration-150 ease-out hover:text-brand-red focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-red" data-id="element-710" data-mp="fpgou3s7p8ud">
                      {method.value}
                    </a>
                    {method.helper && <p className="mt-1 text-sm text-brand-gray" data-id="element-711" data-mp="3f2wbwggpni80">{method.helper}</p>}
                  </div>
                </li>)}
            </ul>

            <a href="mailto:Results@GetAdROI.com?subject=Free%20Marketing%20Audit" className="group mt-10 inline-flex items-center gap-2 rounded-md bg-brand-red px-8 py-4 text-base font-bold text-white shadow-md transition-colors duration-150 ease-out hover:bg-brand-red-dark focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-red focus-visible:ring-offset-2" data-id="element-712" data-mp="355rtmrpzk6wh">
              GET FREE MARKETING AUDIT
              <ArrowRightIcon className="h-5 w-5 transition-transform duration-150 ease-out group-hover:translate-x-0.5" aria-hidden="true" data-id="element-713" data-mp="255zoexw9gb5z" />
            </a>
          </div>
        </div>
      </section>
    </>;
}